import { useState } from "react";
import { Link } from "react-router-dom";
import { COURSES, STAGE_COLORS } from "./trainingData";

const FILTERS = [
  { id: "all", label: "All ten levels" },
  { id: "FOUNDATION", label: "Foundation" },
  { id: "CORE", label: "Core" },
  { id: "EXPERT", label: "Expert" },
  { id: "red", label: "Offensive / red team" },
  { id: "blue", label: "Defensive / blue team" },
  { id: "grc", label: "GRC & risk" },
  { id: "ai", label: "AI security" },
];

export default function CoursesSection() {
  const [filter, setFilter] = useState("all");
  const [openCourses, setOpenCourses] = useState([]);

  const toggleOpen = (lvl) => {
    setOpenCourses((prev) =>
      prev.includes(lvl) ? prev.filter((x) => x !== lvl) : [...prev, lvl]
    );
  };

  const match = (co) =>
    filter === "all" || co.stage === filter || co.roles.includes(filter);

  const visible = COURSES.filter(match);

  return (
    <section id="courses" className="max-w-[1200px] mx-auto px-4 py-12 sm:px-6 md:px-10 sm:py-22">
      <div className="max-w-[720px] mb-5 sm:mb-9">
        <div
          className="font-mono text-[12px] text-[#71717a] mb-[18px]"
          style={{ letterSpacing: "0.18em" }}
        >
          04 — THE TEN COURSES
        </div>
        <h2
          className="font-bold text-white mb-[18px]"
          style={{
            fontSize: "clamp(30px, 3.7vw, 46px)",
            lineHeight: 1.06,
            letterSpacing: "-0.03em",
          }}
        >
          Every course in the track, in full
        </h2>
        <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa]">
          Take the whole track for $499, or buy a single level if you already
          have the ground under you. This is the most current syllabus we
          have ever shipped: every one of the ten courses carries a dedicated
          block of AI security topics, refreshed for 2026. Expand any course
          for the full syllabus — the AI topics sit at the end of each one.
        </p>
      </div>

      <div className="flex flex-wrap gap-2 mb-8 items-center">
        <span
          className="font-mono text-[11px] text-[#52525b] mr-2"
          style={{ letterSpacing: "0.12em" }}
        >
          FILTER
        </span>
        {FILTERS.map((f) => {
          const on = filter === f.id;
          return (
            <button
              key={f.id}
              type="button"
              onClick={() => setFilter(f.id)}
              className={
                on
                  ? "bg-white text-black border border-white rounded-full px-4 py-2 text-[13px] font-semibold cursor-pointer font-[inherit]"
                  : "bg-transparent text-[#a1a1aa] border border-[#27272a] rounded-full px-4 py-2 text-[13px] font-semibold cursor-pointer font-[inherit]"
              }
            >
              {f.label}
            </button>
          );
        })}
      </div>

      <div className="flex flex-col gap-4">
        {visible.map((co) => {
          const isOpen = openCourses.includes(co.lvl);
          const sc = STAGE_COLORS[co.stage];
          return (
            <div
              key={co.lvl}
              className="border border-[#27272a] rounded-[14px] bg-[#09090b] overflow-hidden"
            >
              <div className="p-5 sm:p-[30px] flex flex-col sm:grid sm:grid-cols-[auto_1fr_auto] sm:gap-6 sm:items-start">
                <div className="w-[54px] h-[54px] border border-[#3f3f46] rounded-[10px] flex flex-col items-center justify-center">
                  <span
                    className="font-mono text-[9px] text-[#71717a]"
                    style={{ letterSpacing: "0.1em" }}
                  >
                    LVL
                  </span>
                  <span className="text-[20px] font-bold leading-none">
                    {co.lvl}
                  </span>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-3 flex-wrap mb-2.5">
                    <h3
                      className="text-[19px] sm:text-[23px] font-bold m-0"
                      style={{ letterSpacing: "-0.02em" }}
                    >
                      {co.title}
                    </h3>
                    <span
                      className="font-mono text-[10px] tracking-[0.12em] whitespace-nowrap px-2 py-[3px] rounded-[5px]"
                      style={{ color: sc.fg, border: `1px solid ${sc.bd}` }}
                    >
                      {co.stage}
                    </span>
                    <span className="font-mono text-[11px] text-[#71717a]">
                      {co.difficulty}
                    </span>
                  </div>
                  <p className="text-[15px] leading-[1.65] text-[#a1a1aa] m-0 mb-[18px] max-w-[720px]">
                    {co.desc}
                  </p>
                  <div className="flex flex-wrap gap-[26px] text-[13px] text-[#71717a] font-mono">
                    <span>{co.weeks} WEEKS</span>
                    <span>{co.mods} MODULES</span>
                    <span>{co.labs} LABS</span>
                    <span className="text-[#a1a1aa]">CERT: {co.cert}</span>
                  </div>
                </div>
                <div className="flex flex-col gap-2.5 items-stretch">
                  <div className="text-center flex items-baseline justify-center gap-2">
                    <span className="font-mono text-[14px] text-[#52525b] line-through">
                      {co.was}
                    </span>
                    <span
                      className="text-[20px] sm:text-[24px] font-bold"
                      style={{ letterSpacing: "-0.02em" }}
                    >
                      {co.price}
                    </span>
                  </div>
                  <a
                    href="#enroll"
                    className="bg-white text-black px-5 py-[11px] rounded-[7px] font-semibold text-[14px] text-center hover:bg-[#e4e4e7] transition-colors"
                  >
                    Enroll
                  </a>
                  <Link
                    to={`/training/${co.slug}`}
                    className="bg-transparent border border-[#a3e635] text-[#a3e635] px-5 py-[11px] rounded-[7px] font-semibold text-[14px] text-center hover:bg-[#a3e635] hover:text-black transition-colors"
                  >
                    View full syllabus →
                  </Link>
                  <button
                    type="button"
                    onClick={() => toggleOpen(co.lvl)}
                    className="bg-transparent border border-[#3f3f46] text-[#d4d4d8] px-5 py-[11px] rounded-[7px] font-semibold text-[14px] cursor-pointer font-[inherit] hover:border-white hover:text-white transition-colors"
                  >
                    {isOpen ? "Hide syllabus" : "Full syllabus"}
                  </button>
                </div>
              </div>

              {isOpen && (
                <div className="border-t border-[#27272a] p-5 sm:p-[30px] grid grid-cols-1 sm:grid-cols-[1.2fr_1fr] gap-6 sm:gap-10 bg-black">
                  <div>
                    <div
                      className="font-mono text-[11px] text-[#71717a] mb-4"
                      style={{ letterSpacing: "0.14em" }}
                    >
                      SYLLABUS — {co.mods} MODULES
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
                      {co.modules.map((m, i) => (
                        <div
                          key={i}
                          className="flex gap-2.5 text-[14px] text-[#d4d4d8] leading-snug"
                        >
                          <span className="text-[#a3e635]">/</span>
                          {m}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="grid gap-[22px] content-start">
                    <div>
                      <div
                        className="font-mono text-[11px] text-[#71717a] mb-2.5"
                        style={{ letterSpacing: "0.14em" }}
                      >
                        TOOLS YOU WILL USE
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {co.tools.map((t, i) => (
                          <span
                            key={i}
                            className="border border-[#27272a] rounded-[5px] px-2.5 py-[5px] font-mono text-[11px] text-[#a1a1aa]"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div>
                      <div
                        className="font-mono text-[11px] text-[#71717a] mb-2"
                        style={{ letterSpacing: "0.14em" }}
                      >
                        CAPSTONE
                      </div>
                      <div className="text-[14px] text-[#d4d4d8] leading-relaxed">
                        {co.capstone}
                      </div>
                    </div>
                    <div>
                      <div
                        className="font-mono text-[11px] text-[#71717a] mb-2"
                        style={{ letterSpacing: "0.14em" }}
                      >
                        OUTCOME
                      </div>
                      <div className="text-[14px] text-[#d4d4d8] leading-relaxed">
                        {co.outcome}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
